// Schedule-only release. This file deliberately contains no booking or checkout client.
(() => {
  const query = new URLSearchParams(window.location.search);
  const lang = ['ja', 'en'].includes(query.get('lang')) ? query.get('lang') : (document.documentElement.lang === 'en' ? 'en' : 'ja');
  document.documentElement.lang = lang;
  document.title = lang === 'en' ? 'Workshops · New dates coming soon | TOKYO MIZUHIKI' : 'ワークショップ・日程準備中｜東京水引';
  document.querySelectorAll('[data-language]').forEach(link => {
    const target = new URL(window.location.href);
    target.searchParams.set('lang', link.dataset.language);
    target.hash = '';
    link.href = target.href;
    link.setAttribute('aria-current', String(link.dataset.language === lang));
  });
  document.querySelectorAll('[data-alt-ja]').forEach(img => { img.alt = img.dataset[lang === 'en' ? 'altEn' : 'altJa']; });
})();
